import { ReactElement } from 'react'
import { Flex, VStack, Text } from '@chakra-ui/react'

import ImageLink from '@/features/Services/components/atoms/ImageLink'
import DATA_LIST from '@/features/Services/constants'

interface Props {
  id?: string
}

function LinkSection({ id }: Props): ReactElement {
  return (
    <VStack
      spacing="8"
      sx={{
        maxW: '1192px',
        py: 16,
        px: 1,
        m: 'auto',
      }}
    >
      <Text
        as="h1"
        sx={{
          fontWeight: 'bold',
          fontSize: {
            base: '28px',
            md: '40px',
          },
        }}
      >
        นโยบายอื่น ๆ ของเรา
      </Text>
      <Flex
        id={id}
        sx={{
          flexWrap: 'wrap',
          justifyContent: 'center',
          '& > *': {
            m: 4,
          },
        }}
      >
        {DATA_LIST.map((datum) => {
          return (
            <ImageLink
              key={datum.TITLE}
              href={datum.HREF}
              title={datum.TITLE}
              description={datum.SUBTITLE}
              image={datum.LINK_IMAGE}
              gradient={datum.GRADIENT}
            />
          )
        })}
      </Flex>
    </VStack>
  )
}

export default LinkSection
